import { render, staticRenderFns } from "./videoAlertView2.vue?vue&type=template&id=2cd560aa"
import script from "./videoAlertView2.vue?vue&type=script&lang=js"
export * from "./videoAlertView2.vue?vue&type=script&lang=js"
import style0 from "./videoAlertView2.vue?vue&type=style&index=0&id=2cd560aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports